import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MandateHomeComponent } from './mandate-home/mandate-home.component';
import { GenericlinkComponent } from './genericlink/genericlink.component';
import { RazorPayThankyouComponent } from './RazorpayResponsePage/razor-pay-thankyou/razor-pay-thankyou.component';
import { RazorPayFailureComponent } from './RazorpayResponsePage/razor-pay-failure/razor-pay-failure.component';
import { ShortenedJourneryComponent } from './shortened-journery/shortened-journery.component';
import { SachetJourneyComponent } from './sachet-journey/sachet-journey.component';

const routes: Routes = [ 
  { path: "", redirectTo: "MandateHome", pathMatch: "full" },
  {path: "MandateHome", component: MandateHomeComponent },
  {path: "genericLink", component: GenericlinkComponent},
  {path: "RazorPayThankyou", component: RazorPayThankyouComponent},
  {path: "RazorPayFailure", component: RazorPayFailureComponent},
  {path: "ShortendJourney", component: ShortenedJourneryComponent},
  {path: "SachetJourney", component: SachetJourneyComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
